import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@nerdwallet/currency';

import './no-cards-found.less';

const NoCardsFound = ({ resetFilters }) => (
  <div className="no-cards-found-container">
    <div className="no-cards-found">
      <span className="empty-wallet-icon" />
      <p>It looks like we don&apos;t have any cards that match your filters.</p>
      <Button onClick={resetFilters}>Reset filters</Button>
    </div>
  </div>
);

NoCardsFound.propTypes = {
  resetFilters: PropTypes.func.isRequired,
};

export default NoCardsFound;
